'use client';

import { useWhitelabelConfigContext } from '@/contexts/WhitelabelConfigContext';

export const useWhitelabelConfig = () => useWhitelabelConfigContext();
